export const STICKY_PAGE_ACTIONS_TEST_ID = {
    WRAPPER: 'sticky-page-actions-wrapper',
    ACTION: 'sticky-page-action',
    BADGE_COUNT: 'sticky-page-action-badge-count',
};
